import React from "react";

/**
 * @function Spinner
 * @description for commomn Spinner
 * @returns JSX for Spinner
 */

const Spinner = () => {
  return (
    <div className="overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
